import { useMemo } from 'react';
import { getRemotionEnvironment, Sequence, useVideoConfig } from 'remotion';
import { generateCaptionPages } from '../../libs/caption/generate-caption-pages';
import CaptionsPages from '../Captions/CaptionsPages';
import { useLoadRemotionFont } from '../hooks/useLoadRemotionFont';
import { CaptionsTrack } from '@/player-config/src/types/RemotionPlayerConfigTypes/Track/CaptionsTrack/CaptionsTrack';
import { ElementsTrack } from '@/player-config/src/types/RemotionPlayerConfigTypes/Track/ElementsTrack';
import { CompositionConfig } from '@/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';

export const CaptionsTrackComponent = ({
  track,
  elementTracks,
  onOutlineRelease,
  canEditCaptions = true,
  disableCaptionsDragging = false,
  disableCaptionsResize = false,
  onOutlineResize
}: {
  track: CaptionsTrack;
  elementTracks?: ElementsTrack[];
  onOutlineRelease: CompositionConfig['onOutlineRelease'];
  canEditCaptions?: boolean;
  disableCaptionsDragging?: boolean;
  disableCaptionsResize?: boolean;
  onOutlineResize: CompositionConfig['onOutlineResize'];
}) => {
  const isPreview = getRemotionEnvironment().isPlayer;
  const { fps } = useVideoConfig();
  const font = track.font;

  const { isPending } = useLoadRemotionFont({ font });

  const captionPages = useMemo(() => {
    if (!track.metadata) {
      return track.pages ?? [];
    }
    if (isPending) {
      return [];
    }
    return generateCaptionPages(track.metadata, elementTracks ?? [], fps, track.fromFrame);
  }, [track.metadata, elementTracks, fps, isPending, track.pages, track.fromFrame]);

  return (
    <Sequence from={track.fromFrame} durationInFrames={track.toFrame - track.fromFrame}>
      <CaptionsPages
        pages={captionPages}
        onOutlineRelease={onOutlineRelease}
        canEditCaptions={isPreview && canEditCaptions}
        drift={0}
        font={track.font}
        disableCaptionsDragging={disableCaptionsDragging}
        disableCaptionsResize={disableCaptionsResize}
        onOutlineResize={onOutlineResize}
      />
    </Sequence>
  );
};
